import AnimatedCounter from '@components/common/AnimatedCounter';

const HeroSection = () => {
  const stats = [
    { label: 'Internships & Tutoring', value: 4 },
    { label: 'Organizations', value: 4 },
    { label: 'Countries', value: 2 },
    { label: 'Technical Skills', value: 10 },
  ];

  return (
    <section className="relative overflow-hidden py-20 sm:py-24 lg:py-32 px-4 sm:px-6 lg:px-8">
      {/* Gradient background */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(to bottom right, var(--color-theme-1), var(--color-theme-2))'
        }}
      >
        {/* Ambient shapes */}
        <div
          className="absolute top-0 -left-4 w-96 h-96 rounded-full mix-blend-multiply filter blur-3xl opacity-20"
          style={{ backgroundColor: 'var(--color-accent-2)' }}
        ></div>
        <div
          className="absolute -bottom-8 right-0 w-96 h-96 rounded-full mix-blend-multiply filter blur-3xl opacity-10"
          style={{ backgroundColor: 'var(--color-accent-3)' }}
        ></div>
      </div>

      <div className="container mx-auto relative z-10 max-w-7xl">
        <div className="space-y-12">
          {/* Title Section */}
          <div className="flex flex-col md:items-center space-y-6">
            <div className="space-y-4 md:text-center">
              <h1
                className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-heading font-extrabold tracking-tight"
                style={{ color: 'var(--color-heading)' }}
              >
                Experience and Research
              </h1>
              <p
                className="text-lg sm:text-xl md:text-2xl font-semibold max-w-3xl md:mx-auto"
                style={{ color: 'var(--color-subheading)' }}
              >
                Real-world learning through internships, tutoring, and independent research
              </p>
            </div>

            <p
              className="text-base sm:text-lg leading-relaxed max-w-3xl md:mx-auto md:text-center"
              style={{ color: 'var(--color-subtle)' }}
            >
              During high school, I sought opportunities beyond the classroom through local and international internships, tutoring programs, and independent research. These experiences provided hands-on exposure to cutting-edge technologies, educational impact, and real-world problem-solving in professional environments.
            </p>
          </div>

          {/* Stats Grid - Horizontal scroll on mobile */}
          <div className="pt-8">
            {/* Mobile: Horizontal scroll */}
            <div className="md:hidden flex gap-4 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide">
              {stats.map((stat, index) => (
                <div
                  key={index}
                  className="p-6 rounded-xl transition-all duration-300 min-w-[160px] flex-shrink-0 snap-center"
                  style={{
                    backgroundColor: 'var(--color-card-bg)',
                    borderColor: 'var(--color-card-border)',
                    borderWidth: '1px',
                    borderStyle: 'solid'
                  }}
                >
                  <div className="space-y-2">
                    <div
                      className="text-4xl font-bold"
                      style={{ color: 'var(--color-accent-6)' }}
                    >
                      <AnimatedCounter end={stat.value} duration={2000} />
                      {stat.value >= 10 && '+'}
                    </div>
                    <div
                      className="text-sm font-medium"
                      style={{ color: 'var(--color-subtle)' }}
                    >
                      {stat.label}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Desktop: Grid */}
            <div className="hidden md:grid grid-cols-2 md:grid-cols-4 gap-6">
              {stats.map((stat, index) => (
                <div
                  key={index}
                  className="p-6 rounded-xl transition-all duration-300 hover:shadow-card-hover"
                  style={{
                    backgroundColor: 'var(--color-card-bg)',
                    borderColor: 'var(--color-card-border)',
                    borderWidth: '1px',
                    borderStyle: 'solid'
                  }}
                >
                  <div className="space-y-2">
                    <div
                      className="text-4xl sm:text-5xl font-bold"
                      style={{ color: 'var(--color-accent-6)' }}
                    >
                      <AnimatedCounter end={stat.value} duration={2000} />
                      {stat.value >= 10 && '+'}
                    </div>
                    <div
                      className="text-sm sm:text-base font-medium"
                      style={{ color: 'var(--color-subtle)' }}
                    >
                      {stat.label}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
